function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "18",
  viewBox: "0 0 24 18"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20 0H4C1.794 0 0 1.794 0 4v10c0 2.206 1.794 4 4 4h16c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4zm2 14c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6.441l7.788 5.452c.62.434 1.416.65 2.212.65.796 0 1.592-.216 2.212-.65L22 6.44V14zm-8.935-3.746c-.557.39-1.573.39-2.13 0L2 4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2l-8.935 6.254z"
}));